module.exports = __webpack_public_path__ + "static/hazel.2f1edff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hazel.jpg
// module id = 63
// module chunks = 65579394461380 159014900043430 246227742792961